import { Box, Button, Card, CardContent, CircularProgress, Skeleton, Stack, Typography } from '@mui/material';
import { AddRounded as AddIcon } from '@mui/icons-material';

import { usePaymentMethods } from '@/hooks/queries/subscription/usePaymentMethods';

import { ACCENT, ACCENT_HOVER } from '../_shared';
import PaymentMethodItem from './PaymentMethodItem';
import { useNicePayBillingFlow } from './useNicePayBillingFlow';

const PaymentMethodsSection = () => {
    const { data: methods, isLoading } = usePaymentMethods();
    const billing = useNicePayBillingFlow();

    return (
        <Box>
            <Stack direction="row" alignItems="baseline" justifyContent="space-between" sx={{ mb: 1.25 }}>
                <Typography variant="subtitle1" sx={{ fontWeight: 800 }}>
                    결제 수단
                </Typography>
            </Stack>

            <Stack spacing={1.5}>
                {isLoading ? (
                    [0, 1].map((i) => <Skeleton key={i} variant="rectangular" height={70} sx={{ borderRadius: 2 }} />)
                ) : methods && methods.length > 0 ? (
                    methods.map((m) => <PaymentMethodItem key={m.id} method={m} />)
                ) : (
                    <Card variant="outlined" sx={{ borderRadius: 2 }}>
                        <CardContent>
                            <Typography variant="body2" color="text.secondary">
                                등록된 결제 카드가 없어요. 유료 플랜을 구독하려면 먼저 카드를 등록해주세요.
                            </Typography>
                        </CardContent>
                    </Card>
                )}

                <Box>
                    <Button
                        onClick={() => billing.start()}
                        disabled={billing.isPending}
                        startIcon={billing.isPending ? <CircularProgress size={14} color="inherit" /> : <AddIcon />}
                        variant="outlined"
                        sx={{
                            borderColor: ACCENT,
                            color: ACCENT,
                            fontWeight: 700,
                            borderRadius: 2,
                            textTransform: 'none',
                            px: 2,
                            py: 1,
                            cursor: 'pointer',
                            transition: 'transform 120ms ease, background-color 120ms ease',
                            '&:hover': {
                                borderColor: ACCENT_HOVER,
                                color: ACCENT_HOVER,
                                bgcolor: 'rgba(251,109,72,0.04)',
                                transform: 'translateY(-1px)',
                            },
                        }}
                    >
                        {billing.isPending ? '진행 중…' : '카드 추가'}
                    </Button>
                </Box>
            </Stack>
        </Box>
    );
};

export default PaymentMethodsSection;
